import { observer } from 'mobx-react-lite'
import { Alert, Button } from 'shared/ui'
import { ResetPasswordInputs } from 'pages/auth/pages/reset/ui/ResetPassword/ui/ResetPasswordInputs/ResetPasswordInputs'
import { type ResetPasswordStore } from 'pages/auth/pages/reset/ui/ResetPassword'
import styles from './styles.module.scss'

type IFormProps = {
  store: ResetPasswordStore
}

export const ResetPasswordForm = observer(({ store }: IFormProps) => {
  const { error, loading, handleResetPassword } = store

  return (
    <div className={styles.wrap}>
      {error && (
        <Alert
          className={styles.alertError}
          item={{
            type: 'error',
            desc: error,
          }}
        />
      )}

      <ResetPasswordInputs store={store} />

      <Button
        className={styles.button}
        typeBtn='contained'
        type='button'
        onClick={handleResetPassword}
        loading={loading}
        disabled={loading}
        text={'Save password & Sign in'}
        contained={'primary'}
        fullWidth
      />
    </div>
  )
})

export default ResetPasswordForm
